var map = {
	"./home-hero-1.jpg": 131,
	"./home-hero-2.jpg": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/home\-hero\-.*\.jpg$
// module id = 130
// module chunks = 0